// Full searchable radio details from the supplied 2023 statewide channel plan.
export default String.raw`51.1|136.0000|0.0|136.0000|.0.0|H|N|
52.1|136.0000|0.0|136.0000|.0.0|H|N|
53.1|136.0000|0.0|136.0000|.0.0|H|N|
54.1|136.0000|0.0|136.0000|.0.0|H|N|
55.1|151.25750|D503|151.25750|D503|L|N|
55.2|151.16000|D503|151.16000|D503|L|N|
55.3|151.17500|D503|151.17500|D503|L|N|
55.4|151.19000|D503|151.19000|D503|L|N|
55.5|151.25000|D503|151.25000|D503|L|N|
55.6|151.32500|D503|151.32500|D503|L|N|
55.7|151.34000|D503|151.34000|D503|L|N|
55.8|151.37000|D503|151.37000|D503|L|N|
55.9|151.38500|D503|151.38500|D503|L|N|
55.10|151.40000|D503|151.40000|D503|L|N|
55.11|151.44500|D503|151.44500|D503|L|N|
55.12|151.46000|D503|151.46000|D503|L|N|
55.13|159.29250|D503|159.29250|D503|L|N|
55.14|159.30750|D503|159.30750|D503|L|N|
55.15|151.35500|103.5|159.30000||H|N|
55.16|151.26500|103.5|159.33000||H|N|
55.17|151.17500|136.5|159.45000||H|N|
55.18|151.19000|146.2|159.22500||H|N|
55.19|154.76250|123.0|159.18000|000.0|H|N|
55.20|155.90250|186.2|159.27750||H|N|
55.21|159.36750|192.8|159.36750|192.8|L|N|
55.22|151.37000|192.8|151.37000|192.8|L|N|
55.23|151.38500|192.8|151.38500|192.8|L|N|
55.24|156.07500|156.7|156.07500|156.7|H|N|
55.25|151.18250|D503|151.18250|D503|L|N|
55.26|151.34750|D503|151.34750|D503|L|N|
55.27|151.39250|D503|151.39250|D503|L|N|
55.28|159.38250|D503|159.38250|D503|L|N|
55.29|151.24250|D503|151.24250|D503|L|N|
55.30|159.24750|D503|159.24750|D503|L|N|
55.31|154.92000|156.7|154.92000|156.7|H|N|
55.32|154.93500|156.7|154.93500|156.7|H|N|
55.33|168.62500|000.0|168.62500|110.9|L|N|Emergency`;
